import { render, staticRenderFns } from "./ActionsForCodes.vue?vue&type=template&id=46f242c9"
import script from "./ActionsForCodes.vue?vue&type=script&lang=ts"
export * from "./ActionsForCodes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports